"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WHITELABEL_SELECTOR_CLASS = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _marked = require("marked");
var _xss = _interopRequireDefault(require("xss"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../theme"));
var _variables = require("../css/variables");
const EXTERNAL_NAME = 'markdown';
const WHITELABEL_SELECTOR_CLASS = exports.WHITELABEL_SELECTOR_CLASS = `anvil-${EXTERNAL_NAME}`;
const getDeclaration = ({
  property,
  value,
  selectors,
  isImportant,
  declarations,
  blockName,
  applyToElementDirectly
}) => (0, _variables.createVariablizedCss)({
  variablePrefix: EXTERNAL_NAME,
  property,
  value,
  isImportant,
  selectors,
  declarations,
  blockName,
  applyToElementDirectly
});
const Mark = _styledComponents.default.div`
  w pre {
    width: 100%;
    padding: 12px 15px;
    overflow: auto;

    white-space: pre;
    ${getDeclaration({
  property: 'color',
  value: 'white'
})}
    ${getDeclaration({
  property: 'background',
  value: _theme.default.colors.black
})}
  }

  strong {
    font-weight: 600;
  }

  img {
    max-width: 100%;
  }

  hr:first-child {
    margin-top: 20px !important;
  }
  hr:last-child {
    margin-bottom: 20px !important;
  }
`;
function buildRenderer({
  allowLinks,
  allowHeadings,
  linksOpenNewTab
}) {
  const renderer = new _marked.marked.Renderer();
  if (linksOpenNewTab) {
    renderer.link = function (href, title, text) {
      if (!allowLinks) return text;
      const link = _marked.marked.Renderer.prototype.link.call(this, href, title, text);
      return link.replace('<a', "<a target='_blank' ");
    };
  }
  if (!allowHeadings) {
    renderer.heading = (text, level, raw) => `<p><strong>${text}</strong></p>`;
  }
  return renderer;
}
const Markdown = ({
  children,
  className,
  linksOpenNewTab,
  lineBreaksForNewlines,
  templateReplacements,
  allowLinks,
  allowHeadings,
  // new, from the app
  renderTemplate
}) => {
  if (!children) {
    console.error('Markdown component requires children. Rendered null.');
    return null;
  }
  const markedOptions = {
    breaks: !!lineBreaksForNewlines
  };
  if (allowHeadings || linksOpenNewTab) {
    markedOptions.renderer = buildRenderer({
      allowLinks,
      allowHeadings,
      linksOpenNewTab
    });
  }
  if (templateReplacements) {
    children = renderTemplate(children, templateReplacements, {
      inValueForm: true
    });
  }
  return /*#__PURE__*/_react.default.createElement(Mark, {
    className: `markdown ${className || ''} ${WHITELABEL_SELECTOR_CLASS}`,
    dangerouslySetInnerHTML: {
      __html: (0, _xss.default)((0, _marked.marked)(children, markedOptions))
    }
  });
};
Markdown.defaultProps = {
  allowLinks: true,
  allowHeadings: false,
  linksOpenNewTab: true,
  lineBreaksForNewlines: false
};
Markdown.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.string.isRequired,
  linksOpenNewTab: _propTypes.default.bool,
  lineBreaksForNewlines: _propTypes.default.bool,
  templateReplacements: _propTypes.default.object,
  allowLinks: _propTypes.default.bool,
  allowHeadings: _propTypes.default.bool,
  renderTemplate: _propTypes.default.func
};
var _default = exports.default = Markdown;